// extracted by mini-css-extract-plugin
module.exports = {"rate-img":"RateImg_rate-img__jnoaD","rate-img-box":"RateImg_rate-img-box__zlvum"};